import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { busca_aluno_sem_nota } from "../../services/api";

const AlunosSemNotas = (props) => {

    let cod_unidade = props.un;
    let sig = props.sig;
    let dis = props.dis;
    let turma = props.tu;

    console.log("cod_unidade=", cod_unidade);
    console.log("sig=", sig);
    console.log("dis=", dis);
    console.log("turma=", turma);


    const [data2, setData2] = useState([]);

    const fetchData = async () => {
        try {
            const response = await busca_aluno_sem_nota(cod_unidade, sig, dis, turma);
            console.log("RES=", response);
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, [cod_unidade, sig, dis, turma]);



    return (
        <div className="">
            <Table striped bordered hover responsive size="sm">
                <thead>
                    <tr>
                        <th>Matricula</th>
                        <th>Nome</th>
                    </tr>
                </thead>
                <tbody>
                    {data2.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item.matricula}</td>
                                <td>{item.nome}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    )
}
export default AlunosSemNotas;